import { AutogenModelPayee401krateHdr, AutogenRowPayee401krateHdr } from "./autogen/AutogenModelPayee401krateHdr";

export class ModelPayee401krateHdr extends AutogenModelPayee401krateHdr<RowPayee401krateHdr> {
	constructor() {
		super(RowPayee401krateHdr);
	}
}

export class RowPayee401krateHdr extends AutogenRowPayee401krateHdr {
}